/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {getSetting, ResponseData, showDialog} from '@dvrd/dvr-controls';
import {createCheckout, getStripePortal, setupIntent} from "./requestSender";
import Subscription from "../models/subscriptionModel";
import {loadStripe} from "@stripe/stripe-js";
import {SubscriptionStatus} from "./interfaces";

type Resolver = { success: boolean | undefined, subscription: Subscription | null, data: ResponseData };
const apiKey = getSetting('stripeApiKey'), stripePromise = loadStripe(apiKey);

export const createSetupIntent = async (accountID: string): Promise<Resolver> => {
    return new Promise((resolve) => {
        setupIntent({
            account_id: accountID,
            callback: (data: ResponseData) => {
                const subscription: Subscription | null = data.success ? new Subscription(data.subscription) : null;
                resolve({subscription, data, success: data.success});
            }
        });
    })
};

export const startCheckout = (accountID: string, successUrl: string, cancelUrl: string, callback?: VoidFunction,
                              paymentMethod?: 'sepa_debit' | 'card') => {
    createCheckout({
        data: {account_id: accountID, success_url: successUrl, cancel_url: cancelUrl, payment_method: paymentMethod},
        callback: async (data: ResponseData) => {
            if (data.success) {
                const stripe = await stripePromise, {session_id} = data,
                    result = await stripe?.redirectToCheckout({sessionId: session_id});
                if (!result || result.error) showDialog(result?.error.message || 'Er is iets misgegeaan');
                if (callback) callback();
            }
        }
    });
};

export const loadStripePortal = (returnUrl: string, accountID: string): Promise<string> => new Promise((resolve, reject) => {
    getStripePortal({
        data: {account_id: accountID, return_url: returnUrl}, callback: (data: ResponseData) => {
            if (data.success) resolve(data.url);
            else reject(data.message);
        }
    });
});

export const inactiveSubs = [SubscriptionStatus.INACTIVE, SubscriptionStatus.FAILURE, SubscriptionStatus.CANCELED, SubscriptionStatus.UNPAID];

export function getSubscriptionLabel(status: SubscriptionStatus): string {
    if (status === SubscriptionStatus.ACTIVE)
        return 'Actief';
    else if (inactiveSubs.includes(status))
        return 'Inactief';
    else if (status === SubscriptionStatus.FREE)
        return 'Gratis';
    else if (status === SubscriptionStatus.CANCELED)
        return 'Gestopt';
    else if (status === SubscriptionStatus.TRIAL)
        return 'Proefperiode';
    return 'Onbekend';
}